import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './ToolsPage.css';

const ToolsPage = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const error = searchParams.get('error');
    if (error === 'forbidden') {
      setShowError(true);
      const timer = setTimeout(() => {
        setShowError(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);

  const tools = [
    {
      id: 'event-manager',
      title: 'Event Manager',
      description: 'Gestione eventi, partner e obiettivi',
      icon: '📅',
      route: '/event-manager',
      allowedRoles: ['admin', 'AM', 'viewer']
    },
    {
      id: 'dashboard-viewer',
      title: 'Dashboard Viewer',
      description: 'Visualizza dashboard e analisi avanzate',
      icon: '📊',
      route: '/dashboard',
      allowedRoles: ['admin', 'viewer']
    },
    {
      id: 'ekinext',
      title: 'Ekinext',
      description: 'Gestione feedback prodotti e test clienti',
      icon: '💡',
      route: '/ekinext',
      allowedRoles: ['admin']
    }
  ];

  const availableTools = tools.filter(tool => 
    tool.allowedRoles.includes(user?.role)
  );

  const handleToolClick = (route) => {
    navigate(route);
  };

  return (
    <div className="tools-page">
      <nav className="navbar navbar-dark bg-primary px-4 py-3">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Community Pro Event Tools</span>
          <div className="d-flex align-items-center">
            <span className="text-white me-3">
              Utente: <strong>{user?.username || user?.role}</strong>
            </span>
            <button className="btn btn-light btn-sm" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="tools-container">
        {showError && (
          <div className="container mt-3">
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
              Non hai i diritti di accesso a questa sezione.
              <button 
                type="button" 
                className="btn-close" 
                onClick={() => setShowError(false)}
              ></button>
            </div>
          </div>
        )}

        <div className="tools-header">
          <h1>Seleziona un Tool</h1>
          <p>Scegli lo strumento che vuoi utilizzare</p>
        </div>

        <div className="tools-grid">
          {availableTools.map(tool => (
            <div
              key={tool.id}
              className="tool-card"
              onClick={() => handleToolClick(tool.route)}
            >
              <div className="tool-icon">{tool.icon}</div>
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
              <button className="tool-button">Apri</button>
            </div>
          ))}
        </div>

        {availableTools.length === 0 && (
          <div className="container mt-5">
            <div className="alert alert-warning text-center">
              Nessun tool disponibile per il tuo ruolo.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ToolsPage;
